import React from 'react';
import { FontIcon, getTheme, IStyle, ITheme, mergeStyleSets } from '@fluentui/react';
import { xlate, xlationContext } from '../../../../../framework/utils/i18n';
import { toColor, toRgbaFunctionString } from '../../../../../framework/utils/color';

xlationContext('Timing section notes section expander button');

interface IPRIVATE_MARKDOWN_TIMING_SECTION_SECTION_EXPANDERProps {
  displayNotes: boolean;
  onClicked: React.MouseEventHandler<HTMLButtonElement>;
}

const getStyleClasses = (theme: ITheme) => {

  const hoverColor = toColor(theme.palette.neutralQuaternary);
  hoverColor!.alpha = 80;

  const main: IStyle = {
    all: 'unset',
    width: '5.8em',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    color: theme.palette.neutralPrimary,
    cursor: 'pointer',

    '&:focus': {
      outline: `1px dashed ${theme.palette.white}`,
    },
    '&:hover': {
      backgroundColor: toRgbaFunctionString(hoverColor),
    },
    '&:active': {
      opacity: 1,
    }
  };

  const icon: IStyle = {
    fontSize: '1.5em',
  };

  return mergeStyleSets({
    main,
    icon,
  });
}

export const PRIVATE_MARKDOWN_TIMING_SECTION_SECTION_EXPANDER: React.FunctionComponent<IPRIVATE_MARKDOWN_TIMING_SECTION_SECTION_EXPANDERProps> = (props) => {
  const theme = getTheme();
  const styles = getStyleClasses(theme);

  return (
    <button
      className={styles.main}
      aria-label={props.displayNotes ? xlate('Collapse notes section') : xlate('Expand notes section')}
      onClick={props.onClicked}
    >
      <FontIcon
        className={styles.icon}
        iconName={props.displayNotes ? 'ChevronUp' : 'ChevronDown'}
        aria-hidden
      />
    </button>
  );
};
